import { unityColorTokens } from '../../unityTokens';
import { ChronosphereColor } from './types';

export const unityPurple: ChronosphereColor = {
  50: unityColorTokens['--color-purple-50'],
  100: unityColorTokens['--color-purple-100'],
  150: unityColorTokens['--color-purple-200'],
  200: unityColorTokens['--color-purple-300'],
  300: unityColorTokens['--color-purple-400'],
  400: unityColorTokens['--color-purple-500'],
  500: unityColorTokens['--color-purple-600'],
  600: unityColorTokens['--color-purple-700'],
  700: unityColorTokens['--color-purple-800'],
  800: unityColorTokens['--color-purple-900'],
  850: unityColorTokens['--color-purple-950'],
  900: unityColorTokens['--color-purple-1000'],
  950: unityColorTokens['--color-purple-1000'],
};

export const purple: ChronosphereColor = {
  50: '#F2ECFD',
  100: '#E3D7FA',
  150: '#D3C2F6',
  200: '#C4ADF3',
  300: '#B497F0',
  400: '#A582ED',
  500: '#956DE9',
  600: '#8658E6',
  700: '#6D47BD',
  800: '#543694',
  850: '#3C256A',
  900: '#231441',
  950: '#0A0318',
};
